import { render, staticRenderFns } from "./dialogrobot.vue?vue&type=template&id=2de670ce&scoped=true&"
import script from "./dialogrobot.vue?vue&type=script&lang=js&"
export * from "./dialogrobot.vue?vue&type=script&lang=js&"
import style0 from "./dialogrobot.vue?vue&type=style&index=0&id=2de670ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de670ce",
  null
  
)

export default component.exports